import { useMemo } from "react";

import { IBarGraphContent } from "@ryde/shared";

/** Memoized labels / values / maxValue derived from a report bar-graph content. */
export const useDashboardChartPoints = (
  content: IBarGraphContent,
): { labels: string[]; values: number[]; maxValue: number } =>
  useMemo(() => {
    const labels = content.entities.map(entity => entity.subLabel);
    const values = content.entities.map(entity => entity.value);
    return { labels, values, maxValue: Math.max(...values, 0) };
  }, [content]);
